/* 离群通知-- Server-->Client*/
import {log} from '../../log.js'


var WxLeaveGroupNtf = function (ws, event, commandName, bodyStr, bodyObj) {
    log("server message received", commandName, bodyObj);
};
export default WxLeaveGroupNtf;